export const environment = {
  BASE_AUTH_URL: "https://dev.admin.talero.eu/",
  BASE_URL: "https://dev.admin.talero.eu/api/",
  AUTH_API_BASE_URL: "https://dev.admin.talero.eu/api",
  production: false,
  imagePath: "assets/images",
};
